/**
 * SIMS-8923 — the one place the consent-form size cap is defined.
 *
 * It used to be a bare `10 * 1024 * 1024` inside UploadButton, and the Enroll Participant
 * modal (which uses a raw <input type="file">, not UploadButton) had no cap at all. Both
 * numbers now come from here so the two upload entry points cannot disagree.
 *
 * 3 MB is sized against AWS, not against what a scanned form needs. When the file is sent
 * through the API as base64 (the legacy `consentFile` transport) it inflates by 4/3, and
 * Lambda's synchronous payload ceiling of 6 MB applies to the whole API Gateway event, not
 * just the body: 3 MB raw becomes ~4 MB of string plus the rest of the enrollment payload,
 * which leaves real headroom. Sending more would trade a clear client-side message for an
 * opaque failure further down.
 *
 * The presigned-upload transport does not have that ceiling — the file goes straight to S3
 * — but the cap is kept common to both so a participant's experience does not depend on
 * which transport their client happens to use.
 */
export const MAX_CONSENT_FILE_BYTES = 3 * 1024 * 1024;

export const MAX_CONSENT_FILE_LABEL = "3 MB";

/** MIME types accepted for a signed consent form. Mirrors the backend's DTO validation. */
export const ACCEPTED_CONSENT_MIME_TYPES = [
	"image/png",
	"image/jpeg",
	"application/pdf",
];
